var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgStores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.274,
    x2: 0.956,
    y2: 0.803,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213bc8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8358",
    "data-name": "Group 8358",
    transform: "translate(4096 -14154)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(-4096 14154)",
    fill: "#213bc8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7180",
    "data-name": "Group 7180",
    transform: "translate(-4897.997 12138.641)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2094",
    "data-name": "Rectangle 2094",
    width: 30,
    height: 24,
    rx: 2,
    transform: "translate(835.759 2055)",
    fill: "#213bc8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7157",
    "data-name": "Path 7157",
    d: "M158.972,1215.328s4.139,6.757,8.495,0c.663.472.817,1.44,1.657,2.185a4.623,4.623,0,0,0,5.544,0c.352-.219.643-1,1.956-2.185a5.939,5.939,0,0,0,3.9,3.11,4.632,4.632,0,0,0,4.171-1.989c1.121-2.248-1.25-5.475-1.25-5.475l-1.1-2.475s-.3-1.781-3.969-1.781H155.722s-2.59.361-3.271,1.781a56.264,56.264,0,0,0-1.851,5.483s-.974,4.174,3.919,4.7S158.972,1215.328,158.972,1215.328Z",
    transform: "translate(683.236 842)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2095",
    "data-name": "Rectangle 2095",
    d: "M5,0H5a5,5,0,0,1,5,5V16a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(845.759 2062.718)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStores);
export default __webpack_public_path__ + "static/media/stores.5dc42778e3320fcba021e3c602036b39.svg";
export { ForwardRef as ReactComponent };